import React from 'react';

interface AdvantageItemProps {
  icon: React.ReactNode; // Иконка передается как компонент
  text: string; // Текст преимущества
}

function AdvantageItem({ icon, text }: AdvantageItemProps) {
  return (
    <div className="flex items-center bg-[#FFE5E5] w-[540px] p-4 space-x-4">
      <div className="flex justify-center items-center w-10 h-10 bg-white rounded-full">
        {icon}
      </div>
      <p className="text-sm font-medium text-black">{text}</p>
    </div>
  );
};

export default AdvantageItem;
